<div class="soc-input-wrapper">
    <div *ngIf="label || alertLabel" class="soc-input-info-wrapper">
        <label *ngIf="label" class="soc-input-lbl w-100 text-start">{{label}}</label>
        <label *ngIf="alertLabel" class="soc-input-lbl w-100 text-end" [ngClass]="{'soc-input-alert-success': status == infoStatusEnum.Success, 'soc-input-alert-error': status == infoStatusEnum.Error}">{{alertLabel}}</label>
    </div>
    <div  [ngClass]="{'soc-success-field': status == infoStatusEnum.Success, 'soc-error-field': status == infoStatusEnum.Error}">
        <input [disabled]="disabled" type="text" class="soc-input-field soc-input-text" [(ngModel)]="input" (ngModelChange)="inputChange.emit(input)" [placeholder]="placeholder ? placeholder : ''">
    </div>
</div>